import script from "./FieldRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldRenderer.vue?vue&type=script&setup=true&lang=js"

import "./FieldRenderer.vue?vue&type=style&index=0&id=0d28b857&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d28b857"]])

export default __exports__